import { inApp } from "@/common/js/constant";
import { getCommonAttrs } from "@didi/x-tracker";
import { trackEvent } from '@/utils/omega'
import toast from "react-hot-toast";
/**
 * @title 设置标题
 * @param {String} nativeTitle h5页面标题
 */
export interface setTitleObj {
    nativeTitle: string;
}
const setTitle = (obj: setTitleObj): void => {
    if (inApp) {
        window.Fusion && window.Fusion.loadModule("SofiBridgeModule") && window.Fusion.loadModule("SofiBridgeModule").sfSetTitleWithData(obj);
    } else {
        window.document.title = obj.nativeTitle;
    }
};

/**
 * @title 跳转指定native页面
 * @param {String} routerUrl 跳转URL
 */
export interface openSchemeObj {
    routerUrl: string;
}
const openScheme = (obj: openSchemeObj): void => {
    window.Fusion && window.Fusion.loadModule("SofiBridgeModule") && window.Fusion.loadModule("SofiBridgeModule").sfRouterToAny(obj);
};

/**
 * @title 返回ticket
 * @returns 返回用户的ticket
 */

const getPassportTicket = (): Promise<string> => {
    return new Promise((resolve) => {
        try {
            window.Fusion &&
                window.Fusion.loadModule("SofiBridgeModule") &&
                window.Fusion.loadModule("SofiBridgeModule").sfGetPassportTicket({}, (res: string) => {
                    resolve(res);
                });
        } catch (err) {
            resolve("");
        }
    });
};

/**
 * @title 返回sofipo ticket
 * @returns 返回sofipo ticket
 */

const getSofipoTicket = (): Promise<string> => {
    return new Promise((resolve) => {
        try {
            window.Fusion &&
                window.Fusion.loadModule("SofiBridgeModule") &&
                window.Fusion.loadModule("SofiBridgeModule").sfGetSofipoTicket({}, (res: string) => {
                    resolve(res);
                });
        } catch (err) {
            resolve("");
        }
    });
};
// 监听浏览器返回
const requestBackPressedControl = (callBack:any): Promise<string> => {
    return new Promise((resolve) => {
        try {
            window.Fusion &&
                window.Fusion.loadModule("SofiBridgeModule") &&
                window.Fusion.loadModule("SofiBridgeModule").sfRequestBackPressedControl(()=>{callBack()})
        } catch (err) {
            resolve("");
        }
    });
};
// 取消监听浏览器返回
const cancelBackPressedControl = (): Promise<string> => {
    return new Promise((resolve) => {
        try {
            window.Fusion &&
                window.Fusion.loadModule("SofiBridgeModule") &&
                window.Fusion.loadModule("SofiBridgeModule").sfCancelBackPressedControl();
        } catch (err) {
            resolve("");
        }
    });
};
// 返回
const webBack = (): Promise<string> => {
    return new Promise((resolve) => {
        try {
            window.Fusion &&
                window.Fusion.loadModule("SofiBridgeModule") &&
                window.Fusion.loadModule("SofiBridgeModule").sfWebBack();
        } catch (err) {
            resolve("");
        }
    });
};

// 获取生物核验结果
const getBioVerifyResult = (sign: string): Promise<any> => {
    return new Promise((resolve) => {
        if (!sign) {
            resolve({});
        }
        try {
            if ( window.Fusion &&window.Fusion.loadModule("SofiBridgeModule")) {
                const commonAttrs = getCommonAttrs();
               window.Fusion.loadModule("SofiBridgeModule").sfGetBiometricsVerifyResult({
                    sign,
                    from_source: commonAttrs?.from_source,
                },(res: any)=>{
                    resolve(res)
                });     
            }else{
                trackEvent("tech_sofi_catch_error", {
                    source: 'app.bridge.sfGetBiometricsVerifyResult',
                    data: 'bridge not found',
                });
                resolve({});
            }
                
        } catch (err) {
            trackEvent("tech_sofi_catch_error", {
                source: 'app.bridge.sfGetBiometricsVerifyResult',
                data: JSON.stringify((err)),
            });
            resolve({});
        }
    });
};

/**
 * @title 选择文件
 * @returns 返回文件base64和错误码
 */
export interface chooseFileObj {
    file_extension: string;
    max_size: number;
}

const chooseFile = (obj: chooseFileObj): Promise<any> => {
    return new Promise((resolve) => {        
        try {
            if (window.Fusion &&
                window.Fusion.loadModule("SofiBridgeModule") ) {
                    window.Fusion.loadModule("SofiBridgeModule").sfChooseFile(obj, (res: any) => {
                        resolve(res || {});
                    });
            }else{
                console.log('bridge not found');
                resolve({});
            }
                
        } catch (err) {
            console.log(err,'err');
            trackEvent("tech_sofi_catch_error", {
                source: 'app.bridge.sfChooseFile',
                data: 'sfChooseFile.error',
            });
            resolve({});
        }
    });
};
/**
 * @title 通用链接跳转方法
 * @param {String} linkUrl 跳转链接
 * @param {String} trackSource 埋点来源标识
 */
const navigateToLink = (linkUrl: string, trackSource: string = 'app.navigateToLink'): void => {
    if (!linkUrl) {
        return;
    }
    
    const decodedLinkUrl = decodeURIComponent(linkUrl);
    const walletBridge = window.Fusion && window.Fusion.loadModule('WalletCommonModule');
    
    if (inApp) {
        // 端内调用：根据链接类型调用不同的bridge方法
        // 乘客端和金融端下发的是onelink，dinero端下发的是普通端内链接
        if (decodedLinkUrl.includes("onelink")) {
            if (walletBridge?.openMobileBrowser) {
                try {
                    walletBridge.openMobileBrowser({ uri: decodedLinkUrl });
                    return;
                } catch (e) {
                    // 技术监控打点 - bridge调用失败
                    trackEvent('tech_sofi_catch_error', {
                        source: `${trackSource}.openMobileBrowser.error`,
                        data: JSON.stringify(e),
                    });
                }
            } else {
                // 技术监控打点 - bridge方法不存在
                trackEvent('tech_sofi_catch_error', {
                    source: `${trackSource}.error`,
                    data: '端bridge方法openMobileBrowser不存在',
                });
            }
        } else {
            try {
                APP.openScheme({ routerUrl: decodedLinkUrl });
                return;
            } catch (error) {
                console.error("跳转链接时出错: ", error);
                // 技术打点 - 按钮跳转异常
                trackEvent("tech_sofi_catch_error", {
                    source: `${trackSource}.openScheme.error`,
                    data: error,
                });
            }
        }
        // 降级方案：直接跳转
        window.location.href = decodedLinkUrl;
    } else {
        // 非端内调用，直接跳转
        window.location.href = decodedLinkUrl;
    }
};

const APP = {
    setTitle,
    openScheme,
    getPassportTicket,
    getSofipoTicket,
    requestBackPressedControl,
    cancelBackPressedControl,
    webBack,
    getBioVerifyResult,
    chooseFile,
    navigateToLink
};

// App Bridge相关功能
export const useAppBridge = () => {
  const loadModule = () => {
    return window.Fusion && window.Fusion.loadModule("SofiBridgeModule");
  };

  const checkLogin = (): Promise<boolean> => {
    return new Promise((resolve) => {
      // 模拟检查登录状态
      const module = loadModule();
      if (module && typeof module.sfCheckLogin === 'function') {
        module.sfCheckLogin((result: boolean) => {
          resolve(result);
        });
      } else {
        // 如果没有原生桥接，则假定未登录
        resolve(false);
      }
    });
  };

  const getSofipoTicket = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      const module = loadModule();
      if (module && typeof module.sfGetSofipoTicket === 'function') {
        module.sfGetSofipoTicket((result: { token: string } | string) => {
           // Handle both object and string return types if needed, though typically string
           const token = typeof result === 'string' ? result : result?.token;
           if (token) {
            resolve(token);
          } else {
            reject(new Error('Failed to get token'));
          }
        });
      } else {
        reject(new Error('SofiBridgeModule not available'));
      }
    });
  };

  const requestLogin = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      const module = loadModule();
      if (module && typeof module.sfRequestLogin === 'function') {
        module.sfRequestLogin((result: any) => {
          // Assuming result indicates success or just callback implies success/completion
          resolve(); 
        });
      } else {
        reject(new Error('SofiBridgeModule not available'));
      }
    });
  };

  return {
    checkLogin,
    getSofipoTicket,
    requestLogin,
  };
};
export default APP;
